import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Jeton manquant."); return; }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState("ok"); setMsg(data.message); })
      .catch((err) => { setState("error"); setMsg(formatApiError(err.response?.data?.detail)); });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(var(--surface))]/90 p-8 text-center" data-testid="verify-email">
        <Link to="/" className="font-heading text-2xl font-black tracking-tight">Vytali<span className="text-primary">Flix</span></Link>
        <div className="mt-8">
          {state === "loading" && <Loader2 className="mx-auto h-12 w-12 animate-spin text-primary" />}
          {state === "ok" && <CheckCircle2 className="mx-auto h-12 w-12 text-primary" />}
          {state === "error" && <XCircle className="mx-auto h-12 w-12 text-destructive" />}
          <p className="mt-4 text-sm text-muted-foreground">{msg || "Vérification…"}</p>
          <Link to="/login" className="mt-6 inline-block rounded-full bg-primary px-6 py-2.5 font-semibold text-primary-foreground">Aller à la connexion</Link>
        </div>
      </div>
    </div>
  );
}
